import { render, staticRenderFns } from "./StoreInfoFormPanel.vue?vue&type=template&id=52c82104&scoped=true"
import script from "./StoreInfoFormPanel.vue?vue&type=script&lang=js"
export * from "./StoreInfoFormPanel.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoFormPanel.vue?vue&type=style&index=0&id=52c82104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c82104",
  null
  
)

export default component.exports